/**
 * getDashboardRouterKey.js — which dashboard router DashboardPage mounts.
 * Shaped by: G3b; G5b owner 2026-10-12.
 * Invariants: same checks and the same order as DashboardPage. A missing
 *   users.role is onboarding before the JWT admin claim. FDE and Global TCI
 *   Manager flags reach institutionAdmin after patient and regional_admin.
 * Related: DashboardPage.jsx, appCatalog.js ROUTER_DASHBOARD_APPS.
 */
import { isPatientOrP2LikeRole } from "shared/utils/constants/p2LikeRoles";
import {
  USERS_ROLE_BTYB_MARKETER,
  USERS_ROLE_MARKETING_EXECUTIVE,
} from "constants/userOrgRoles";

export function getDashboardRouterKey({
  userData,
  isGlobalAdmin = false,
  isFdeDc = false,
  isFdeC = false,
  isFdeT = false,
  hasGtmAccess = false,
} = {}) {
  // DashboardPage redirects a document with no role before the router switch.
  if (userData && !userData.role) return "onboarding";
  if (isGlobalAdmin) return "globalAdmin";
  if (userData?.role === "regional_admin") {
    return String(userData.region || "").trim()
      ? "regionalAdmin"
      : "regionalAdminMissingRegion";
  }
  if (isPatientOrP2LikeRole(userData?.role)) return "patient";
  if (
    userData?.role === "admin" ||
    userData?.role === "dscr-admin" ||
    isFdeDc ||
    isFdeC ||
    isFdeT ||
    hasGtmAccess
  ) {
    return "institutionAdmin";
  }
  if (
    userData?.role === "professional" ||
    userData?.role === "professional-chartmind"
  ) {
    return "professional";
  }
  if (userData?.role === USERS_ROLE_MARKETING_EXECUTIVE) return "marketingExecutive";
  if (userData?.role === USERS_ROLE_BTYB_MARKETER) return "btybMarketer";
  if (userData?.role === "facility") return "facility";
  return "notSetUp";
}
